import { EVENTOS } from '@/conversas/notificacaoSom';

/**
 * Bloco "Notificações sonoras" do painel de Configurações.
 *
 * Todo o estado mora no `useNotificacaoSom`, que vive na lista: o mesmo hook
 * que detecta os eventos é o dono das preferências, então não há duas cópias
 * para divergir. Este componente só desenha e chama de volta.
 *
 * Era um diálogo inteiro antes de as seções ganharem configuração; virou bloco
 * quando o painel passou a ter dois assuntos. O conteúdo não mudou.
 */
export default function BlocoNotificacaoSom({
  preferencias,
  bloqueado,
  alternarGeral,
  alternarEvento,
  tocarTeste,
}) {
  const ligado = preferencias.geral;

  return (
    <section className="config-bloco">
      <h3 className="config-titulo">Notificações sonoras</h3>
      <div>
        <label className="som-linha som-geral">
          <input type="checkbox" checked={ligado} onChange={alternarGeral} />
          <span className="som-rotulo">
            <strong>Tocar som no inbox</strong>
            <span className="campo-ajuda">
              Vale só para você, neste navegador. Fica gravado para as próximas visitas.
            </span>
          </span>
        </label>

        {/* O aviso do autoplay só aparece depois da tentativa: dizer de antemão
            "seu navegador pode bloquear" assustaria sem motivo, já que na
            maioria das vezes o clique destrava e está resolvido. */}
        {bloqueado && ligado && (
          <p className="erro">
            O navegador bloqueou o áudio. Clique em "Tocar teste" — se ainda assim não
            sair som, verifique se esta aba não está muda.
          </p>
        )}

        <div className={ligado ? 'som-eventos' : 'som-eventos apagado'}>
          <p className="som-legenda">Quando tocar</p>

          {EVENTOS.map((evento) => (
            /* O botão fica FORA do <label> de propósito: dentro dele, o clique
               em qualquer filho é encaminhado para o checkbox, e testar o som
               ligaria ou desligaria o evento junto. */
            <div key={evento.id} className="som-linha">
              <label className="som-escolha">
                <input
                  type="checkbox"
                  checked={preferencias.eventos[evento.id] === true}
                  onChange={() => alternarEvento(evento.id)}
                  // Só o checkbox é desabilitado com o geral desligado — o
                  // botão de teste continua vivo, porque ouvir o som ANTES de
                  // ligar é justamente como a pessoa decide se quer ligar.
                  disabled={!ligado}
                />
                <span className="som-rotulo">
                  <strong>{evento.label}</strong>
                  <span className="campo-ajuda">{evento.descricao}</span>
                </span>
              </label>

              <button
                type="button"
                className="btn-texto compacto"
                onClick={() => tocarTeste(evento.id)}
                title={`Ouvir o som de "${evento.label}"`}
              >
                Tocar teste
              </button>
            </div>
          ))}
        </div>

        <p className="campo-ajuda">
          A conversa que você está lendo não apita — e vários avisos ao mesmo tempo tocam
          uma vez só, não um som para cada.
        </p>
      </div>
    </section>
  );
}
